/* Правила диалогов (Настройки → Диалоги): автозакрытие, заметка/сообщение при закрытии, категории, итог ИИ.
   Читают все (нужны в окне диалога), меняют владелец и администраторы. */
import { api } from "@/lib/api";

export type RuleCategory = { id: string; name: string; description: string; color: "primary" | "accent" | "neutral" | string };

export type InboxRules = {
  autoClose: boolean;
  closeAfter: number;
  closeUnit: "hours" | "days" | "weeks";
  keepUnread: boolean;
  closeMessage: boolean;
  closeMessageText: string;
  requireNote: boolean;
  autoNotes: boolean;
  sentiment: boolean;
  remindHours: number;
  categories: RuleCategory[];
  canEdit: boolean;
  /** на сервере есть ключ OpenRouter — итоги ИИ при закрытии работают */
  ai: boolean;
};

export const inboxRulesApi = {
  get: () => api<InboxRules>("/settings/inbox-rules"),
  update: (patch: Partial<Omit<InboxRules, "canEdit" | "ai">>) => api<InboxRules>("/settings/inbox-rules", { method: "PATCH", json: patch }),
};
